import styled from "styled-components";
import { colorsPalettes, fonts, rgba } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { setFontVariant } from "@similarweb/styles";

export const ModalContent = styled(FlexColumn)`
    font-family: ${fonts.$robotoFontFamily};
    color: ${colorsPalettes.carbon["300"]};
    width: 100%;
`;

export const Title = styled.div`
    display: flex;
    justify-content: center;
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
    line-height: 24px;
`;

export const Subtitle = styled.div`
    display: flex;
    justify-content: center;
    ${setFontVariant("value", colorsPalettes.carbon[400])};
    line-height: 16px;
    margin-top: 8px;
`;

export const CardsWrapper = styled(FlexRow)`
    margin-top: 36px;
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

export const UnderCardText = styled.div`
    opacity: 0;
    display: flex;
    justify-content: center;
    line-height: 16px;
    margin-top: 16px;
    ${setFontVariant("value", colorsPalettes.carbon[200])};
`;

export const CardAndTextWrapper = styled(FlexColumn)`
    justify-content: center;
    margin-right: 14px;
    margin-left: 7px;
`;

export const HomePageCard = styled.div`
    width: 233px;
    border: 1px solid ${rgba(colorsPalettes.carbon[100], 0.8)};
    border-radius: 6px;
    &:hover {
        cursor: pointer;
        box-shadow:
            0px 8px 24px rgba(9, 37, 64, 0.08),
            0px 16px 32px rgba(9, 37, 64, 0.08);
        transition: box-shadow 0.25s ease-out;
        & + ${UnderCardText} {
            opacity: 1;
        }
    }
`;

export const Image = styled.img`
    display: block;
    border-radius: 6px 6px 0 0;
`;

export const ModalFooter = styled.div`
    display: flex;
    margin-top: 32px;
    line-height: 16px;
    width: 100%;
    justify-content: center;
`;
